"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoopDomainEvent = void 0;
const EventBase_1 = require("./EventBase");
const schema_1 = require("./schema");
/**
 * Debug event that is never dispatched
 */
let NoopDomainEvent = class NoopDomainEvent extends EventBase_1.DomainEventBase {
};
NoopDomainEvent = __decorate([
    schema_1.DomainEvent({ name: "noop", version: 1 })
], NoopDomainEvent);
exports.NoopDomainEvent = NoopDomainEvent;
//# sourceMappingURL=NoopEvent.js.map